<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :class="color ? '' : buttonClass"
        :color="color || undefined"
        :dark="!!color"
        icon
        v-bind="attrs"
        v-on="on"
        :aria-label="label"
        :disabled="disabled"
        :loading="loading"
        @click.stop="$emit('click', $event)"
      >
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
    </template>
    <span>{{ tooltip || label }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'AppHeaderIconButton',
  props: {
    icon: { type: String, required: true },
    /** Accessible name and default tooltip text */
    label: { type: String, required: true },
    /** Optional longer tooltip (defaults to label) */
    tooltip: { type: String, default: '' },
    /** e.g. primary-gradient, warning-gradient (ignored when color is set) */
    buttonClass: { type: String, default: 'primary-gradient' },
    /** Vuetify color name (e.g. success) — flat icon button instead of gradient */
    color: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  }
};
</script>
